import { BodyFormulario, ContainerFormularioHistorico, FooterFormulario, HeaderFormulario, OutrosLogsContainer, OutrosLogsHeader, OutrosLogsBody, SubLogList, SubLogItem } from "./styled";
import { TitleH1 } from "../../../../../Components/CustomUi/titleH1";
import { Checkbox, Tag } from "antd";
import { Select } from "../../../../../Components/CustomUi/Select";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Input from "../../../../../Components/CustomUi/input";
import ButtonCustom from "../../../../../Components/ButtonCustom";

import { faCode, faCodeBranch, faFloppyDisk, faList, faPlus, faTag, faUser, faTrash, faMobile } from "@fortawesome/free-solid-svg-icons";
import TextArea from "../../../../../Components/CustomUi/textarea";
import { cores, dadosFilter } from "../meta";
import { Render } from "../../../../../Components/CustomUi/render";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tabs from "../../../../../Components/Tabs";

interface FormTimelineProps {
    onCancel: () => void;
    update: number;
    dadosLogs: any[];
    dataUsuarioLog: any[];
    openForm: boolean;
    tipoLog: string;
    setTipoLog: React.Dispatch<React.SetStateAction<string>>;
    titulo: string;
    setTitulo: React.Dispatch<React.SetStateAction<string>>;
    usuario: string;
    setUsuario: React.Dispatch<React.SetStateAction<string>>;
    branch: string;
    setBranch: React.Dispatch<React.SetStateAction<string>>;
    descricao: string;
    setDescricao: React.Dispatch<React.SetStateAction<string>>;
    showOutrosLogs: boolean;
    setShowOutrosLogs: React.Dispatch<React.SetStateAction<boolean>>;
    novoSubLogTipo: string;
    setNovoSubLogTipo: React.Dispatch<React.SetStateAction<string>>;
    novoSubLogTipoID: number;
    setNovoSubLogTipoID: React.Dispatch<React.SetStateAction<number>>;
    novoSubLogDesc: string;
    setNovoSubLogDesc: React.Dispatch<React.SetStateAction<string>>;
    novoSubLogPrivado: boolean;
    setNovoSubLogPrivado: React.Dispatch<React.SetStateAction<boolean>>;
    subLogs: any[];
    setSubLogs: React.Dispatch<React.SetStateAction<any[]>>;
    tipoLogID: number;
    setTipoLogID: React.Dispatch<React.SetStateAction<number>>;
    usuarioID: number;
    setUsuarioID: React.Dispatch<React.SetStateAction<number>>;
    versao: string;
    setVersao: React.Dispatch<React.SetStateAction<string>>;
    tab_tipo_aplicacao: string;
    setTab_tipo_aplicacao: React.Dispatch<React.SetStateAction<string>>;
    salvarLog: () => void;
    isLoading: boolean;
}

export const FormularioHistorico = ({
    onCancel,
    update,
    dadosLogs,
    dataUsuarioLog,
    openForm,
    tipoLog,
    setTipoLog,
    titulo,
    setTitulo,
    usuario,
    setUsuario,
    branch,
    setBranch,
    descricao,
    setDescricao,
    showOutrosLogs,
    setShowOutrosLogs,
    novoSubLogTipo,
    setNovoSubLogTipo,
    novoSubLogTipoID,
    setNovoSubLogTipoID,
    novoSubLogDesc,
    setNovoSubLogDesc,
    novoSubLogPrivado,
    setNovoSubLogPrivado,
    subLogs,
    setSubLogs,
    tipoLogID,
    setTipoLogID,
    usuarioID,
    setUsuarioID,
    versao,
    setVersao,
    tab_tipo_aplicacao,
    setTab_tipo_aplicacao,
    salvarLog,
    isLoading
}: FormTimelineProps) => {
    console.log('update', update)
    const [openSelectTipo, setOpenSelectTipo] = useState<boolean>(false);
    const [openSelectUsuario, setOpenSelectUsuario] = useState<boolean>(false);
    const [openSelectSubTipo, setOpenSelectSubTipo] = useState<boolean>(false);

    useEffect(() => {
        if (!openForm) {
            setShowOutrosLogs(false);
        }
    }, [openForm]);

    const adicionarSubLog = () => {
        if (novoSubLogTipo && novoSubLogDesc) {
            setSubLogs([...subLogs, { tipo: novoSubLogTipoID, descricao: novoSubLogDesc, privado: novoSubLogPrivado }]);
            setNovoSubLogTipo("");
            setNovoSubLogDesc("");
            setNovoSubLogPrivado(false);
        }
    };

    return (
        <ContainerFormularioHistorico
            onCancel={onCancel}
            footer={null}
            width={600}
            open={openForm}
            title={false}
            destroyOnClose
        >

            <HeaderFormulario>
                <TitleH1>{update === 0 ? 'Cadastrar novo Log' : 'Editar Log'}</TitleH1>
            </HeaderFormulario>

            <BodyFormulario>

                <Render condition={update === 0}>
                    <Tabs
                        tabs={[
                            { descricao: 'Web', icone: faCode },
                            { descricao: 'App', icone: faMobile },
                        ]}
                        selecionado={tab_tipo_aplicacao}
                        trackWidth={280}
                        onChange={setTab_tipo_aplicacao}
                    />
                </Render>

                <Select
                    label="Tipo do log"
                    placeholder="Selecione o tipo do log"
                    icon={faCode}
                    value={tipoLog}
                    onChange={setTipoLog}
                    onChangeID={setTipoLogID}
                    open={openSelectTipo}
                    trigger={setOpenSelectTipo}
                    items={dadosFilter}
                    descricaoItem={"nome"}
                    idItem={"cod"}
                />
                <Input
                    label="Título"
                    icon={faList}
                    placeholder="Digite o título"
                    value={titulo}
                    onChange={setTitulo}
                />
                <Select
                    label="Usuário"
                    placeholder="Selecione o usuário"
                    icon={faUser}
                    value={usuario}
                    onChange={setUsuario}
                    onChangeID={setUsuarioID}
                    open={openSelectUsuario}
                    trigger={setOpenSelectUsuario}
                    items={dataUsuarioLog}
                    descricaoItem={"nome"}
                    idItem={"cod"}
                />
                <Input
                    label="Branch"
                    icon={faCodeBranch}
                    placeholder="Digite a branch"
                    value={branch}
                    onChange={setBranch}
                />
                <Render condition={update !== 0 || tab_tipo_aplicacao === "App"}>
                    <Input
                        label="Versão"
                        icon={faTag}
                        placeholder="Digite a versão"
                        value={versao}
                        onChange={setVersao}
                    />
                </Render>
                <TextArea
                    label="Descrição"
                    placeholder="Digite a descrição"
                    value={descricao}
                    onChange={setDescricao}
                />

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {!showOutrosLogs && (
                        <ButtonCustom onClick={() => setShowOutrosLogs(true)} icon={<FontAwesomeIcon icon={faPlus} />} type="secondary">
                            Adicionar outro log
                        </ButtonCustom>
                    )}
                </div>

                <AnimatePresence>
                    {showOutrosLogs && (
                        <motion.div
                            initial={{ height: 0, opacity: 0, overflow: "hidden", marginBottom: 0 }}
                            animate={{ height: "auto", opacity: 1, marginBottom: 15 }}
                            exit={{ height: 0, opacity: 0, overflow: "hidden", marginBottom: 0 }}
                            transition={{ duration: 0.3, ease: "easeInOut" }}
                        >
                            <OutrosLogsContainer>
                                <OutrosLogsHeader>Outros logs</OutrosLogsHeader>
                                <OutrosLogsBody>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox checked={novoSubLogPrivado} onChange={(e) => setNovoSubLogPrivado(e.target.checked)}>Log privado</Checkbox>
                                    </div>
                                    <Select
                                        label="Tipo"
                                        icon={faCode}
                                        value={novoSubLogTipo}
                                        onChange={setNovoSubLogTipo}
                                        onChangeID={setNovoSubLogTipoID}
                                        open={openSelectSubTipo}
                                        trigger={setOpenSelectSubTipo}
                                        items={dadosFilter}
                                        descricaoItem={"nome"}
                                        idItem={"cod"}
                                        placeholder="Selecione o tipo"
                                    />
                                    <TextArea
                                        label="Descrição"
                                        placeholder="Descrição curta do item..."
                                        value={novoSubLogDesc}
                                        onChange={setNovoSubLogDesc}
                                    />

                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <ButtonCustom
                                            onClick={adicionarSubLog}
                                            icon={<FontAwesomeIcon icon={faPlus} />}
                                            type="secondary"
                                        >
                                            Adicionar
                                        </ButtonCustom>
                                    </div>
                                </OutrosLogsBody>

                                <Render condition={subLogs.length > 0}>
                                    <SubLogList>
                                        {subLogs.map((sq, idx) => {
                                            const tipoNum = Number(sq.tipo);
                                            const configCores = cores[tipoNum as keyof typeof cores] || cores[1];
                                            const nomeTipo = dadosFilter.find(f => f.cod === tipoNum)?.nome || 'LOG';

                                            return (
                                                <SubLogItem key={idx}>
                                                    <div className="sub-log-info">
                                                        <div className="sub-log-desc">
                                                            {sq.privado && <span style={{ fontSize: '11px', color: '#999', marginRight: '5px' }}>Privado</span>}
                                                            {sq.descricao}
                                                        </div>
                                                        <div className="sub-log-header">
                                                            <Tag
                                                                color={configCores.bg}
                                                                style={{
                                                                    color: configCores.text,
                                                                    margin: 0
                                                                }}
                                                            >
                                                                {nomeTipo.toUpperCase()}
                                                            </Tag>
                                                        </div>
                                                    </div>
                                                    <div className="sub-log-actions">
                                                        <button
                                                            className="btn-delete-log"
                                                            onClick={() => {
                                                                const newLogs = subLogs.filter((_, i) => i !== idx);
                                                                setSubLogs(newLogs);
                                                            }}
                                                            title="Remover Log"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                style={{ fontSize: '13px', color: 'red' }}
                                                            />
                                                        </button>
                                                    </div>
                                                </SubLogItem>
                                            );
                                        })}
                                    </SubLogList>
                                </Render>
                            </OutrosLogsContainer>
                        </motion.div>
                    )}
                </AnimatePresence>
            </BodyFormulario>

            <FooterFormulario >
                <ButtonCustom onClick={salvarLog} type="primary" icon={<FontAwesomeIcon icon={faFloppyDisk} />} loading={isLoading} disabled={isLoading}>Salvar</ButtonCustom>
            </FooterFormulario>

        </ContainerFormularioHistorico>
    );
}